<template>
    <div class="d-flex flex-column">
        <input-select
            v-bind="{ ...$props, value: selectValue, options: cookedOptions }"
            null-option="-"
            @update:value="handleSelectInput"
        />

        <transition name="fade">
            <input-text
                v-if="checkOther"
                ref="otherText"
                class="w-100 mt-24"
                :inner-label="innerLabel"
                :value="otherValue"
                :disabled="disabled"
                :maxlength="maxlength"
                @update:value="updateOtherValue"
                @mounted="focusOnOther"
            />
        </transition>
    </div>
</template>

<script>
import InputSelect from "~/components/inputs/InputSelect"
import InputText from "~/components/inputs/InputText"
import { ucfirst } from "~/lib/utils"

export default {
    props: {
        ...InputSelect.props,

        options: {
            type: Array,
        },

        optionsSrc: {
            type: String,
        },

        value: {
            type: [String, Number],
            default: null,
        },

        maxlength: {
            type: [String, Number],
            default: null,
        },
    },

    emits: ["update:value"],

    data() {
        return {
            remoteOptions: [],
            selectValue: null,
            otherValue: null,
        }
    },

    computed: {
        cookedOptions() {
            const options = this.optionsSrc ? this.remoteOptions : this.options
            const otherOption = {
                text: ucfirst(this.$t("common.others", 1)),
                value: "OTHER",
            }
            if (!options || !options.length) return [otherOption]
            return [...options, otherOption]
        },

        checkOther() {
            return this.selectValue == "OTHER"
        },
    },

    watch: {
        async optionsSrc() {
            await this.updateOptions()
            this.checkValueInOptions()
        },

        value() {
            this.checkValueInOptions()
        },
    },

    async created() {
        if (this.optionsSrc) {
            await this.updateOptions()
        }
        this.checkValueInOptions()
    },

    methods: {
        async updateOptions() {
            if (this.value && this.value == this.selectValue) {
                this.$emit("update:value", null)
                this.selectValue = null
            }
            if (!this.optionsSrc) {
                this.remoteOptions = []
                this.selectValue = "OTHER"
                return
            }
            this.remoteOptions = await this.$http.fetchData(this.optionsSrc, {
                method: "OPTIONS",
            })
        },

        handleSelectInput(value) {
            this.selectValue = value
            if (value !== "OTHER") {
                this.$emit("update:value", value)
            }
        },

        updateOtherValue(value) {
            this.otherValue = value
            this.$emit("update:value", value)
        },

        checkValueInOptions() {
            if (!this.value) return
            if (this.cookedOptions.find(o => o.value == this.value)) {
                this.selectValue = this.value
                this.otherValue = null
            } else {
                this.selectValue = "OTHER"
                this.otherValue = this.value
            }
        },

        focusOnOther() {
            this.$refs.otherText.setFocus()
        },
    },

    components: {
        InputSelect,
        InputText,
    },
}
</script>
